import { Col, Modal, Row } from 'react-bootstrap';
import CrossSvg from '../../_uLearn/assets/media/close.png';
import Email from '../../_uLearn/assets/media/svg_uLearn/email.svg';
import Phone from '../../_uLearn/assets/media/svg_uLearn/phone-call.svg';
import { studentString } from '../../utils/string';
import { useEffect, useState } from 'react';
import APICallService from '../../api/apiCallService';
import { STUDENT } from '../../api/apiEndPoints';
import Method from '../../utils/methods';
import Loader from '../../Global/loader';
const StudentDetails = (props: any) => {
  const [fetchLoader, setFetchLoader] = useState(true);
  const [details, setDetails] = useState<any>();
  useEffect(() => {
    (async () => {
      setFetchLoader(true);
      await fetchDetails();
      setFetchLoader(false);
    })();
  }, []);
  const fetchDetails = async () => {
    let apiService = new APICallService(
      STUDENT.GET_STUDENT_INFO,
      props.editDetailData._id
    );
    let response: any = await apiService.callAPI();
    if (response) {
      setDetails(response);
    }
    setFetchLoader(false);
  };
  return (
    <>
      <Modal
        {...props}
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-lg-1000px"
        className="border-r10px"
        centered
      >
        <Modal.Header className="border-bottom-0 pb-0 text-center mx-auto">
          <img
            className="close-inner-top"
            width={40}
            height={40}
            src={CrossSvg}
            alt="closebutton"
            onClick={props.onHide}
          />
          <Modal.Title className="fs-26 fw-bolder mw-lg-375px pt-lg-3">
            {studentString.studentDetails}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!fetchLoader ? (
            <Row className="px-lg-6 gy-6">
              <span className="border-r4px fs-18 fw-600 text-gray text-center">
                {details?.associatedSchool[0]?.school[0]?.name +
                  ' ' +
                  studentString.school}
              </span>
              <Col lg={6}>
                <div className="border border-r8px p-5">
                  <h3 className="fs-22 fw-bolder mb-1">
                    {Method.convertDateToDDMMYYYY(details?.dateOfBirth)}
                  </h3>
                  <span className="fs-16 fw-500 text-gray">
                    {studentString.dateOfBirth}
                  </span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="border border-r8px p-5">
                  <h3 className="fs-22 fw-bolder mb-1">
                    {Method.convertDateToDDMMYYYY(details?._createdAt)}
                  </h3>
                  <span className="fs-16 fw-500 text-gray">
                    {studentString.platformDate}
                  </span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="border border-r8px p-5">
                  <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                      <span
                        className="fs-22 fw-bolder mb-2"
                        // style={{ whiteSpace: 'nowrap' }}
                      >
                        {details?.parentsDetails.name}
                      </span>
                      <div className="d-flex align-items-center text-black fs-16 fw-500 me-5 mb-2">
                        <span className="svg-icon svg-icon-4 me-2">
                          <img
                            src={Phone}
                            alt="Phone number"
                          />
                        </span>
                        {details?.parentsDetails.phoneCountry +
                          ' ' +
                          details?.parentsDetails.phone}
                        <div className="d-flex align-items-center text-black fs-16 fw-500 mb-2 mx-5">
                          <span className="svg-icon svg-icon-4 me-2">
                            <img
                              src={Email}
                              alt="Email"
                            />
                          </span>
                          {details?.parentsDetails.email}
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="fs-16 fw-500 text-gray">
                    {studentString.parentsInfo1}
                  </span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="border border-r8px p-5">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <span className="fs-22 fw-bolder mb-2">
                        {details?.guardianDetails.name || 'NA'}
                      </span>
                      <div className="d-flex align-items-center text-black fs-16 fw-500 me-5 mb-2">
                        {details.guardianDetails.phone ? (
                          <span className="svg-icon svg-icon-4 me-2">
                            <img
                              src={Phone}
                              alt="Phone number"
                            />
                          </span>
                        ) : (
                          <></>
                        )}
                        {details?.guardianDetails.phoneCountry &&
                        details?.guardianDetails.phone ? (
                          <>
                            {details?.guardianDetails.phoneCountry}{' '}
                            {details?.guardianDetails.phone}
                          </>
                        ) : (
                          '-'
                        )}
                        <div className="d-flex align-items-center text-black fs-16 fw-500 mb-2 mx-5">
                          {details.guardianDetails.email ? (
                            <span className="svg-icon svg-icon-4 me-2">
                              <img
                                src={Email}
                                alt="Email"
                              />
                            </span>
                          ) : (
                            <></>
                          )}
                          {details?.guardianDetails.email || ''}
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="fs-16 fw-500 text-gray">
                    {studentString.parentsInfo2}
                  </span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="border border-r8px p-5">
                  <h3 className="fs-22 fw-bolder mb-1">
                    {details?.ageGroup?.fromAge && details?.ageGroup?.toAge
                      ? `${details.ageGroup.fromAge} - ${details.ageGroup.toAge} ${studentString.years}`
                      : '-'}
                  </h3>
                  <span className="fs-16 fw-500 text-gray">
                    {studentString.ageGroup}
                  </span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="border border-r8px p-5">
                  <h3 className="fs-22 fw-bolder mb-1">
                    {studentString.class +
                      ' ' +
                      details?.associatedSchool[0]?.classDetails[0]?.class
                        ?.name +
                      ' - ' +
                      details?.associatedSchool[0]?.classDetails[0]
                        ?.classDivision?.name}
                  </h3>
                  <span className="fs-16 fw-500 text-gray">
                    {studentString.classDiv}
                  </span>
                </div>
              </Col>
            </Row>
          ) : (
            <div className="d-flex justify-content-center">
              <Loader loading={fetchLoader} />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default StudentDetails;
